import { client } from "./api";

const STORAGE_USER = "access-ui.user";
const STORAGE_AUTH = "access-ui.authed";
const STORAGE_TOKEN = "access-ui.token";

function readJson(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
}

function writeJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getStoredUser() {
  return readJson(STORAGE_USER);
}

export function setStoredUser(user) {
  if (user) {
    writeJson(STORAGE_USER, user);
    localStorage.setItem(STORAGE_AUTH, "1");
  }
}

export function clearStoredUser() {
  localStorage.removeItem(STORAGE_USER);
  localStorage.removeItem(STORAGE_AUTH);
  localStorage.removeItem(STORAGE_TOKEN);
}

export function isAuthenticated() {
  if (getToken()) return true;
  if (localStorage.getItem(STORAGE_AUTH) === "1") return true;
  return !!getStoredUser();
}

export function getToken() {
  return localStorage.getItem(STORAGE_TOKEN) || "";
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(STORAGE_TOKEN, token);
    localStorage.setItem(STORAGE_AUTH, "1");
  }
}

function extractUser(payload) {
  if (!payload) return null;
  if (payload.user && typeof payload.user === "object") return payload.user;
  if (payload.profile && typeof payload.profile === "object") return payload.profile;
  if (payload.data && typeof payload.data === "object") return payload.data;
  if (payload.username || payload.name || payload.id) return payload;
  return null;
}

export async function login(payload) {
  const res = await client.post("/api/login", payload);
  const data = res.data;
  if (typeof data === "string") {
    setToken(data);
  } else if (data && typeof data === "object") {
    const token = data.token || data.access_token || data.accessToken;
    if (token) setToken(token);
  }
  const user = extractUser(data) || { username: payload.username };
  setStoredUser(user);
  return data;
}

export async function logout() {
  try {
    await client.post("/api/logout");
  } finally {
    clearStoredUser();
  }
}

export async function restoreSession() {
  return isAuthenticated();
}
